<template>
  <div class="teacher-content">
    <div class="title">
      <h3>专业老师团队</h3>
      <div class="tip">专业的老师团队人均从业十年以上，服务案例丰富</div>
    </div>
    <div style="position:relative">
      <div class="swiper-content">
        <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
          <swiper-slide class="swiper-slide" v-for="(item,index) in teacherList" :key="index">
            <div class="img-div">
              <img :src="item.img" class="teacher-img">
            </div>
            <div class="teacher-detail">
              <div class="teacher-info">
                <h3>{{ item.name }}</h3>
                <span>{{ item.tip }}</span>
              </div>
              <div class="introduce">
                <p>{{item.introduce}}</p>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </div>

  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import 'swiper/dist/css/swiper.css';
import teacherBg from '../assets/img/teacherBg.png';
export default {
  name: "TeacherTeam",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        observer: true,
        notNextTick: true,
        direction: "horizontal",
        spaceBetween: 25,
        setWrapperSize: true,
        autoHeight: true,
        slidesPerView: 3,
        slidesPerGroup: 3,
        observeParents: true,
        bgImg: teacherBg,
        zoom: false,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        /*autoplay:false,*/
        speed: 800,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // 允许分页点击跳转
        },
      },
      teacherList: [
        {
          img: "https://oss.fxwljy.com/attach/file1706265641931.jpg",
          name: '武亮',
          tip: '峰学未来副总裁，高报金牌规划师',
          introduce: "峰学未来教育科技有限公司副总裁，峰学未来高报金牌规划师，苏州工业园区人力资源委员会特聘讲师，《强国青年爱国之旅》特邀讲师。五年K12教育工作经验，八年上市企业工作经验，对学生规划有丰富的经验。",
        }, {
          img: "https://oss.fxwljy.com/attach/file1706265640192.jpg",
          name: '高俊逸',
          tip: '峰学未来资深高报师，6年教育行业从业经验',
          introduce: "峰学未来资深高报师，6年教育行业从业经验，曾就职于中国科学院自动化所。尤其精通各理工科专业就业大趋势，擅长挖掘学生兴趣方向和行业发展结合点，是学生最喜欢沟通的老师。",
        }, {
          img: "https://oss.fxwljy.com/attach/file1706265642234.jpg",
          name: '周帅礼',
          tip: '峰学未来资深高报师，华东师范大学软件工程硕士',
          introduce: "峰学未来资深高报师，五年高报经验。华东师范大学软件工程硕士，曾就职于研途，考研方向高端规划师。熟悉高招政策、专业、就业及所对应的考研方向，擅长本+硕七年规划，精准匹配院校和专业。",
        }, {
          img: "https://oss.fxwljy.com/attach/file1706265640773.jpg",
          name: '马志远',
          tip: '峰学未来联合创始人，香港理工硕士研究生',
          introduce: "峰学未来联合创始人，硕士研究生毕业于香港理工大学。金牌升学规划专家，非常擅长于学习指导和专业报考等方面的服务，已经累计指导3000+学生升入理想院校和专业。",
        },

        // {
        //   img: "https://oss.fxwljy.com/attach/file1706265641428.jpg",
        //   name: '唐澄瑶 Cici',
        //   tip: '美国旧金山艺术大学MFA硕士，DBA博士在读',
        //   introduce: "MFA硕士毕业于美国旧金山艺术大学，目前DBA博士在读。过往从事教育行业15年，擅长专业分析、院校规划、政策解读和学生沟通，现在主要负责晋陕云贵川五省的升学规划。",
        // },

        {
          img: "https://oss.fxwljy.com/attach/file1712461255483.jpg",
          name: '陈帅',
          tip: '毕业于扬州大学，善于数据分析整合',
          introduce: '三年体制内工作经验，三年志愿规划经验。为超1000名学子规划志愿，善于数据分析整合，对全国大学信息了解透彻。善于结合学生自身素质特点科学分析，进行对应的志愿规划。'
        }, {
          img: "https://oss.fxwljy.com/attach/file1706265640937.jpg",
          name: '戚天宇',
          tip: '苏州大学金融学本科，玛丽女王学院金融硕士',
          introduce: "拥有卓越金融背景和深厚志愿规划能力的专家，善于根据学生的兴趣、能力和职业目标，为他们量身定制志愿规划方案。通过深入了解不同院校和专业的要求，帮助学生选择合适的志愿组合，提高录取几率。",
        },
        {
          img: "https://oss.fxwljy.com/attach/file1706265641286.jpg",
          name: '苏豪',
          tip: '研究生毕业于加拿大知名院校',
          introduce: '在国外有两年留学生活及两年的工作经验。回国后从事留学行业多年，成功帮助数百名学生踏上出国留学的道路。擅长处理各种复杂背景的学生案例，为每一个学生量身定制最优的选择。',
        },
        {
          img: "https://oss.fxwljy.com/attach/file1706265641124.jpg",
          name: '沙冠丞',
          tip: '从事高考志愿填报行业六年，填报志愿经验丰富',
          introduce: '已完成300+孩子的志愿填报服务，填报志愿经验丰富。除填报志愿外，也积极参加高考规则科研活动，让孩子和家长了解专业，了解院校，并且吃透高考录取政策和规则，帮助孩子进入心仪的院校、专业。',
        },
        {
          img: "https://oss.fxwljy.com/attach/file1706265641611.jpg",
          name: '王旭',
          tip: '英国萨里大学硕士，深耕教育行业八年',
          introduce: "硕士毕业于英国萨里大学，峰学未来规划师。深耕教育行业八年之久，在一线为超过150组的家庭做过升学方面的咨询规划。精于河北、山东、重庆、天津地区的志愿规划服务。",
        }, {
          img: "https://oss.fxwljy.com/attach/file1706265641765.jpg",
          name: '武博越',
          tip: '峰学未来资深高报师，擅长体制内及医学类填报',
          introduce: "峰学未来资深高报师，擅长体制内及医学类高考志愿填报工作。曾经就职于知名教育上市公司、市级体制单位。五年升学规划经验，累计已指导500+学生进入理想高校。",
        },
        {
          img: "https://oss.fxwljy.com/attach/file1706265640000.jpg",
          name: '成名',
          tip: '峰学未来高报规划师',
          introduce: "从事志愿方向规划和高等院校、专业解读多年。有3年银行对公业务工作背景，对当前新兴行业各领域人才需求及产业发展前景有独到见解。主要负责地区：湖北、湖南、江苏、海南、福建、山东、陕西。",
        }, {
          img: "https://oss.fxwljy.com/attach/file1706265640478.jpg",
          name: '韩被被',
          tip: '张雪峰老师麾下第七号规划师，MBA研究生在读',
          introduce: "张雪峰老师麾下第七号规划师，10年财税行业工作经验、MBA研究生在读，专业为家长考生探学校、探专业、探行业，善于帮助家长和考生分析选择合适的院校和专业。",
        }, {
          img: "https://oss.fxwljy.com/attach/file1706265640625.jpg",
          name: '刘魏',
          tip: '成都理工大学，地理学科教研组主编',
          introduce: "峰学志愿规划师，曾任某头部教育机构学管主任、考研院校规划师、高中地理教师。教育行业从业经验10年+，管理服务学生3000+，中高考升学规划讲座主讲，被学生称为行走的高校知识库。",
        },
        {
          img: "https://oss.fxwljy.com/attach/file1761811243112.jpg",
          name:'闾伟',
          tip:'张雪峰高报团队重庆地区负责人',
          introduce:'硕士毕业于中国石油大学(北京)(“双一流”“211”)，曾有多年体制内工作经验。\n' +
              '深耕重庆高考志愿规划领域，精准把握重庆招生政策、院校投档规则与市内外高校优势特色，擅长结合考生分数、兴趣及职业规划，定制个性化填报方案。\n'
        }
      ]
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "SourceHanSansCN";
  src: url("https://oss.fxwljy.com/attach/file1706509868982.otf");
}
@font-face {
  font-family: "SourceHanSansCNBold";
  src: url("https://oss.fxwljy.com/attach/file1706509868791.otf");
}
.teacher-content {
  width: 100%;
  padding-top: 120px;
  /*background: linear-gradient(20deg, #FFFFFF 0%, rgba(255,255,255,0) 100%);*/
  .title {
    width: 100%;
    text-align: center;
    h3 {
      width: 100%;
      /*height: 40px;*/
      font-size: 40px;
      font-family: "SourceHanSansCNBold Microsoft YaHei";
      font-weight: bold;
      color: #0a0d0f;
      line-height: 60px;
    }
    .tip {
      width: 100%;
      /*height: 16px;*/
      font-size: 20px;
      font-family: "SourceHanSansCN Microsoft YaHei";
      font-weight: 400;
      color: #909295;
      line-height: 24px;
      margin-top: 26px;
    }
  }
  .swiper-content {
    width: 1200px;
    margin: 40px auto;
    padding-top: 20px;
    height: 600px;
    overflow: hidden;
    ::v-deep .swiper-wrapper {
      display: flex;
    }
    .swiper-container {
      overflow: visible !important;
      position: static !important;
    }
    .swiper-slide {
      position: relative;
      /*cursor: pointer;*/
      transition: transform 0.3s ease;
    }
    .swiper-slide:hover {
      transform: translateY(-20px);
    }
    .img-div {
      width: 380px;
      height: 310px;
      overflow: hidden;
      border-radius: 16px;
    }
    /*.swiper-slide:hover{
      transform: scale(0.9);
    }*/
    .teacher-img {
      z-index: 100;
      position: relative;
      width: 100%;
      transition: all 0.25s ease;
      display: block;
      height: 100%;
    }
    /*.teacher-img:hover{
      transform: scale(1.1);
    }*/
    .teacher-detail {
      width: 380px;
      position: absolute;
      top: 68%;
      background-image: url("~@/assets/img/teacherBg.png");
      background-size: 100% 100%;
      min-height: 320px;
      z-index: 1000;
      .teacher-info {
        margin: 30px 20px 0 20px;
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(219, 221, 224, 0.5);
        h3 {
          font-size: 20px;
          font-family: "SourceHanSansCNBold Microsoft YaHei";
          font-weight: bold;
          color: #0a0d0f;
          line-height: 30px;
        }
        span {
          font-size: 14px;
          font-family: "SourceHanSansCN Microsoft YaHei";
          font-weight: 400;
          color: #909295;
          line-height: 21px;
          margin-top: 10px;
          display: inline-block;
        }
      }
      .introduce {
        padding: 20px 20px 24px 20px;
        p {
          font-size: 16px;
          font-family: "SourceHanSansCN Microsoft YaHei";
          font-weight: 400;
          color: #0a0d0f;
          line-height: 30px;
          letter-spacing: 1.5px;
          text-align: justify;
          height: 130px;
        }
      }
    }
    .swiper-button-prev {
      background-image: url("~@/assets/img/left.png");
      width: 52px;
      height: 52px;
      background-size: cover;
      top: 45%;
      margin-top: 0;
      left: 260px;
      cursor: pointer;
    }
    .swiper-button-prev:hover {
      background-image: url("~@/assets/img/left-hover.png");
    }
    .swiper-button-next {
      background-image: url("~@/assets/img/right.png");
      width: 52px;
      height: 52px;
      background-size: cover;
      top: 45%;
      margin-top: 0;
      right: 260px;
      cursor: pointer;
    }
    .swiper-button-next:hover {
      background-image: url("~@/assets/img/right-hover.png");
    }
  }
}
</style>